import React ,{useState } from 'react';
import {useDispatch , useSelector}from 'react-redux';



import { modifyEcran,defineAttachments,modifyDisplaymodal,modifyDisplaycalleft, } from '../state/redux';
import { useTickets, useNotifs, useAllmails, useGestionmails,useUser} from '../state/reactquery';

import { simpleSDK } from '../utils/ringover';

import InfoUser from './InfoUser';

import iconmutuello from '../images/menu/iconmutuello.svg';
import iconmutuellobottom from '../images/menu/iconmutuellobottom.svg';
import iconsidebartel  from '../images/iconsidebartel.svg';


import './Sidebar.scss';

const classNames = require('classnames');
function Sidebar({setDisplaynotifs}){

    const dispatch = useDispatch();
    const ecran = useSelector(state=>state.display.ecran) ;
    const displaycalleft = useSelector(state=>state.display.displaycalleft) ;
    // const qualiflead  = useSelector(state=>state.lead.qualiflead) ; 

    const {data: user} = useUser(localStorage.getItem('token'))  ;
    const degrerole =user?.role ==="SUPERADMIN"?0: user?.role ==="COMMERCIAL"?1:user?.role ==="MANAGER"?2:user?.role ==="GESTION"?3:user?.role ==="ADMIN"?4:5 ;
    
    const role_superadmin = degrerole === 0  ||  window.location.hostname==='localhost'  ;
    const role_usercrm = degrerole >0 ;
    const role_gestionadmin = degrerole >2;
    const role_admin = degrerole >3 ;
    const role_manager = degrerole >1 ;



    const {data : notifs} = useNotifs();
//     const {data:tickets}  = useTickets() ; 
    const {data: emailsgestion} = useGestionmails(degrerole >2) ; 
    const {data: emails} = useAllmails() ; 
    const [displayinfouser, setDisplayinfouser] = useState(false) ;

    const mailsnonouverts = emails?.emailsentrants?.filter(x=> x.RecordType!=='Open').sort((a,b) => new Date(b.created_at) - new Date(a.created_at)) ;
    const mailsgestionnonouverts= emailsgestion?.emailsentrants?.filter(x=> x.RecordType!=='Open').sort((a,b) => new Date(b.created_at) - new Date(a.created_at)) 


//     const ticketsnews = tickets?.filter(x=>x['statut']==='new')  ;
    const notifsnoopened  = notifs?.filter(x=>x['opened']===0)  ;

    

const cond_postmark =  window.location.hostname==='localhost' || role_superadmin || user.email ==='jerome@cohen.ltd' ; 

    const clickbell = (e)=>{  setDisplaynotifs(displaynotifs => !displaynotifs)}

    const clickeltmenu = (id)=>{ 
      if(id==='notifsbell'){   setDisplaynotifs(displaynotifs => !displaynotifs)}
        else {dispatch(modifyEcran(id)) ;dispatch(modifyDisplaymodal(null)) ;
    
              dispatch(modifyDisplaymodal(null))  ;
           dispatch(defineAttachments([])); 
          }
    }

      const avatar2 = ()=>(<div className='avatar2' >{(user['lastname']?.charAt(0).toUpperCase()??'' ) + (user['firstname']?.charAt(0).toUpperCase()??'')  }</div>)

      const iconsidebar = (id)=>{
        return(<div  id={id} className={classNames("iconsidebar",id,{'selected':ecran===id})} onClick={()=>clickeltmenu(id)}  >
              {/* { ( id==='ecrantickets'  &&  ticketsnews?.length >0)  &&  <div className={classNames('nbtickets',{'small':ticketsnews.length>99 }  ,{'medium':ticketsnews.length<100 && ticketsnews.length>9 }  ,{'big': ticketsnews.length < 10}   )}  > {ticketsnews.length} </div>} */}
              { ( id==='notifsbell'  &&  notifsnoopened?.length >0)  &&  <div className={classNames('nbtickets',{'small':notifsnoopened.length>99 }  ,{'medium':notifsnoopened.length<100 && notifsnoopened.length>9 }  ,{'big': notifsnoopened.length < 10}   )}  onClick={clickbell}  > {notifsnoopened.length} </div>}
              { ( id==='ecranemails'  &&  mailsnonouverts?.length >0)  &&  <div className={classNames('nbtickets',{'small':mailsnonouverts?.length>99 }  ,{'medium':mailsnonouverts.length<100 && mailsnonouverts.length>9 }  ,{'big': mailsnonouverts < 10}   )}   > {mailsnonouverts?.length} </div>}
              { ( id==='ecranemailsgestion'  &&  mailsgestionnonouverts?.length >0)  &&  <div className={classNames('nbtickets',{'small':mailsgestionnonouverts?.length>99 }  ,{'medium':mailsgestionnonouverts.length<100 && mailsgestionnonouverts.length>9 }  ,{'big': mailsgestionnonouverts < 10}   )} > {mailsgestionnonouverts?.length} </div>}
            </div>) }

      const iconsidebartel = (id)=>(<div  id={id} className='sidebartel'   onClick={sidebartel}  ></div>); 
      const sidebartel = (e)=>{
             e.target.id==='sbaircall' && document.getElementById('workspace')?.classList.toggle('displaynone') ;
            // e.target.id==='sbaircall' && document.getElementById('aircallphone')?.classList.toggle('displaynone') ;
            e.target.id==='sbringover' && simpleSDK?.toggle() ;
      }

      
      const iconsidebarcalendar = ()=>(<div className='displaycalendar' onClick={()=>{dispatch(modifyDisplaycalleft(!displaycalleft))}}  ></div>)

        return(<div className="sidebar">
                    <div className="sidebar_top">
                          <div className="logotop">
                                <img src={iconmutuello}  alt="icon"  heigth="16"/>
                                <img src={iconmutuellobottom}  alt="icon"  heigth="6"/>
                          </div> 
                          { role_superadmin && iconsidebar("ecransuperadmin")  }
                          { (role_superadmin ||  role_gestionadmin || role_admin || window.location.hostname==='localhost'  )&& iconsidebar("ecransuperadmintracks")  }
                          { role_manager && iconsidebar("ecrangestion") }
                          { role_usercrm && iconsidebar("dashboard") }
                          { iconsidebar("ecranemails") }  
                          { role_gestionadmin && iconsidebar("ecranemailsgestion") }
                          { cond_postmark && iconsidebar("ecranpostmark") }
                    </div>   
                    <div className="sidebar_bottom"> 
                        { role_superadmin &&  iconsidebar("dev") }
                        { role_superadmin &&  iconsidebar("dev2") }
                        {user.type_tel === 'aircall'  && iconsidebartel("sbaircall")}
                        {user.type_tel === 'ringover'  && iconsidebartel("sbringover")}
                        { role_admin  &&  iconsidebar("params") }
                        { role_usercrm && iconsidebar("notifsbell") }
                        { (role_usercrm && ecran==='ficheclient') && iconsidebarcalendar() }
                        <div  className='avatardivider'  ></div>
                        <div className='cursorpointer' onClick={()=>setDisplayinfouser(!displayinfouser)}>
                              {localStorage.getItem('imgavatar')?<img  className='avatar' src={localStorage.getItem('imgavatar')} alt='avatar' width='34' height="34"  /> : avatar2()} 
                        </div>    
                    </div>  
                   {displayinfouser && <InfoUser  /> }
            </div>)
        }

export default Sidebar


